/**
 * Base class for all entities.
 */
export abstract class AbstractEntityV1 {
    public id: number|undefined;
    public correlationId: string | undefined;
    public version: number | undefined;
}
